import React, { useEffect, useRef, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { SORateList } from '../TitleList';
import { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSaleOrder, fetchSOQuotationlist, insertSOrateQuotation } from '../../Store/PHPSlice/Sale/SaleOrder';
import { selectItems, selectSOData, selectSOQuotData, selectSOQuotSize } from '../Selectors/Master/ItemSelectors';
import { fetchItemData } from '../../Store/PHPSlice/Item';


const SaleOrderRate = () => {

    const [formData, setFormData] = useState({
        sono: '',
        quotno: '',
        userId: '1',
    });
    const [soPrevData, setSoPrevData] = useState([]);
    const [sizeItem, setSizeItem] = useState([]);
    const [quotItems, setQuotItems] = useState('');
    const [filterQuot, setFilterQuot] = useState([]);
    const [itemNm, setItemNm] = useState('');
    const [barcd, setBarcd] = useState('');
    const [quotNo, setQuotNo] = useState('');
    const [quotItemNo, setQuotItemNo] = useState('');
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const saleorderlist = useSelector(selectSOData);
    const itemlist = useSelector(selectItems);
    const soquotlist = useSelector(selectSOQuotData);

    useEffect(() => {
        dispatch(fetchSaleOrder());
        dispatch(fetchItemData());
        dispatch(fetchSOQuotationlist());
    }, [dispatch]);

    const handleInputChange = (index, field, value) => {
        setSizeItem(prevSizeItems => {
            const updatedItems = [...prevSizeItems];
            updatedItems[index] = { ...updatedItems[index], [field]: value };
            return updatedItems;
        });
    };



    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        // Update form data with the selected dropdown value
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));

        if (dropdownType === 'sono' && value) {
            const selectedList = saleorderlist.data.length > 0
                ? saleorderlist.data.find(val => val.ID === value)
                : null;

            if (selectedList) {
                const itemId = selectedList.itemId;
                const findItem = itemlist.data.length > 0
                    ? itemlist.data.find(val => val.ID === itemId)
                    : null;

                if (findItem) {
                    const itemSize = findItem.size;
                    const sizeArray = itemSize.split(",");

                    const initializedSizeItems = sizeArray.map(val => ({ size: val, rate: '0', mrp: '0' }));
                    setSizeItem(initializedSizeItems);
                    setItemNm(selectedList.itemNm);
                    setBarcd(selectedList.barcode);
                } else {
                    console.log('Item not found:', itemId);
                }
            } else {
                console.log('Selected list not found:', value);
            }

            const soprevdata = saleorderlist.info.length > 0 ? saleorderlist.info.filter((item) => item.soId === value) : [];
            setSoPrevData(soprevdata);
        }


    };

    const handleDropdownChanged = (e, dropdownType) => {
        const { value } = e.target;

        // Update form data with the selected dropdown value
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));

        if (dropdownType === 'quotno' && value) {
            const filterData = soquotlist.data.length > 0 ? soquotlist.data.filter((val) => val.quotId === value) : [];
            setFilterQuot(filterData);;
            const selectnos = soquotlist.quotnos.length > 0 ? soquotlist.quotnos.find((val) => val.ID === value) : [];
            if (selectnos) {
                setQuotNo(selectnos.quotNo);
                setQuotItemNo(selectnos.qItemNo);
                setQuotItems(selectnos.itemNm);
            }
        }
    };

    const handleLinkClick = () => {
        // Create a mapping of sizes and their corresponding rate and MRP from the quotation
        const quotSizeMap = filterQuot.reduce((acc, item) => {
            acc[item.size] = { rate: item.rate, mrp: item.mrp };
            return acc;
        }, {});

        // Update the sizeItem state with the rate and MRP values from the quotation
        const updatedSizeItems = sizeItem.map(item => {
            const quotData = quotSizeMap[item.size];
            return quotData ? { ...item, rate: quotData.rate, mrp: quotData.mrp } : item;
        });

        setSizeItem(updatedSizeItems);
        toast.success('Linked Quotation values to Sale Order');
    };

    function convertIntoOneObject(array, array2, formData) {
        if (array.length > 0 && array2.length > 0) {

            var tableData = {
                size: [...array.map((item) => item.size)],
                rate: [...array2.map((item) => item.rate)],
                crate: [...array.map((item) => item.rate)],
                mrp: [...array2.map((item) => item.mrp)],
                cmrp: [...array.map((item) => item.mrp)],
                // Include formData fields
                soId: formData.sono,
                quotId: formData.quotno,
                userId: formData.userId,

            };
        }
        return tableData;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const finalObject = convertIntoOneObject(sizeItem, soPrevData, formData);
        dispatch(insertSOrateQuotation(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Sale Order Rate Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Titlebar data={SORateList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sale Order Rate - Quotation Wise</h2>
                <Grid  >
                    <Grid item>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="sono">Sale Order No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="sono"
                                                    id="sono"
                                                    name="sono"
                                                    value={formData.sono}
                                                    onChange={(e) => handleDropdownChange(e, 'sono')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {saleorderlist.data.length > 0 ? saleorderlist.data.map((val, index) => (
                                                        <MenuItem key={index} value={val.ID}>{val.sono} - {val.barcode}</MenuItem>
                                                    )) : []}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="quotno">Quotation No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="quotno"
                                                    id="quotno"
                                                    name="quotno"
                                                    value={formData.quotno}
                                                    onChange={(e) => handleDropdownChanged(e, 'quotno')}
                                                    sx={inputStyles}

                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {soquotlist.quotnos.length > 0 ? soquotlist.quotnos.map((val, index) => (
                                                        <MenuItem key={index} value={val.ID}>{val.quotNo} - {val.qItemNo}</MenuItem>
                                                    )) : []}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={8} md={3}>
                                    {sizeItem.length > 0 ? (
                                        <>
                                            <h4>Item : {itemNm}</h4>
                                            <h4>Barcode : {barcd}</h4>
                                            <br />
                                            <TableContainer>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Size</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Rate</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>MRP</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {sizeItem.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 1, border: '1px solid #ccc', width: 5 }} align='center'>{item.size}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        style={{ width: 50, padding: 1 }}
                                                                        value={item.rate}
                                                                        onChange={(e) => handleInputChange(index, 'rate', e.target.value)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        style={{ width: 50, padding: 1 }}
                                                                        value={item.mrp}
                                                                        onChange={(e) => handleInputChange(index, 'mrp', e.target.value)}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        </>) : ''}
                                </Grid>

                                <Grid item xs={8} md={3}></Grid>

                                <Grid item xs={8} md={3}>
                                    {filterQuot.length > 0 ? (
                                        <>
                                            <h4>Item : {quotItems}</h4>
                                            <h4>Quot No : {quotNo}</h4>
                                            <h4>Quot Item No : {quotItemNo}</h4>
                                            <br />
                                            <TableContainer>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Size</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>Rate</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>MRP</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {filterQuot.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 1, border: '1px solid #ccc', width: 5 }} align='center'>{item.size}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        style={{ width: 50, padding: 1 }}
                                                                        value={item.rate}
                                                                        onChange={(e) => handleInputChange(index, 'rate', e.target.value)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #ccc' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        style={{ width: 50, padding: 1 }}
                                                                        value={item.mrp}
                                                                        onChange={(e) => handleInputChange(index, 'mrp', e.target.value)}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        </>) : ''}
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleLinkClick} sx={{ mr: 2 }}>Link</Button>
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default SaleOrderRate;
